import { render } from "./ListBerita.vue?vue&type=template&id=eb285e76"
import script from "./ListBerita.vue?vue&type=script&lang=js"
export * from "./ListBerita.vue?vue&type=script&lang=js"

import "./ListBerita.vue?vue&type=style&index=0&id=eb285e76&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__